import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const HeaderItemContainer = styled(FlexRow)`
    align-items: center;
    gap: 8px;

    .ItemIcon {
        width: 16px;
        height: 16px;
    }
`;

export const HeaderItemText = styled.span`
    ${setFontVariant("subtitle2", carbon[250])};
`;

export const ToRightContainer = styled(FlexRow)`
    margin-left: auto;
    align-items: center;
    gap: 8px;
`;

export const BadgeContainer = styled.div`
    margin-left: -8px;
`;
